export default __webpack_public_path__ + "static/about-us-chad-2984c792376c7aefdf1a82d20cd17287.webp";